/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import abstractCaseTranslations from "./abstractCaseTranslations";
import bankDataTranslations from "./bankDataTranslations";
import abstractLitigationCaseTranslations from "./abstractLitigationCaseTranslations";
import organizationTranslations from "./organizationTranslations";
import personTranslations from "./personTranslations";

const abstractContractClaimTranslations = {
  ...abstractCaseTranslations,
  ...abstractLitigationCaseTranslations,
  buyerPaidStatus: {
    label: "Kaufpreis bezahlt?",
    question: "Wurde der Kaufpreis vollständig gezahlt?",
    options: {
      fully: {
        label: "Ja, vollständig bezahlt",
      },
      partially: {
        label: "Nein, bisher wurde nur eine Anzahlung geleistet",
      },
      none: {
        label: "Nein, es wurde noch nichts gezahlt",
      },
    },
  },
  paymentOrderDate: {
    label: "Datum Mahnbescheid",
  },
  enforcementOrderDate: {
    label: "Zustellung Vollstreckungsbescheid am",
  },
  contractDate: {
    label: "Datum des Vertrags",
  },
  subjectOfDispute: {
    label: "Forderung",
    options: {
      money: {
        label: "Geld",
      },
      goods: {
        label: "Ware/Leistung",
      },
      other: {
        label: "Ich fordere etwas ganz anderes",
      },
    },
  },
  objectiveClient: {
    label: "Ziel",
    options: {
      fulfillment: {
        label: "Erfüllung des Vertrags",
      },
      withdrawal: {
        label: "Rücktritt vom Vertrag",
      },
      replacement: {
        label: "Ersatz oder Austausch",
      },
      repair: {
        label: "Nachbesserung oder Reparatur",
      },
      reduction: {
        label: "Volle oder teilweise Erstattung",
      },
      compensation: {
        label: "Schadensersatz",
      },
      other: {
        label: "Andere Zielsetzung",
      },
    },
  },
  overdueFees: {
    label: "Mahn- oder Inkassogebühren ",
    question: "Welche Mahn- oder Inkassogebühren werden von Ihnen gefordert (falls zutreffend)?",
  },
  clientBankData: {
    ...bankDataTranslations,
  },
  debtCollectionAgency: {
    ...organizationTranslations,
  },
  debtCollectionAgencyReference: {
    label: "Aktenzeichen Inkassobüro",
  },
  personalTextMessage: {
    label: "Ihre Situation und Fragen",
  },
  additionalClients: {
    0: personTranslations,
    1: personTranslations,
    2: personTranslations,
    3: personTranslations,
    4: personTranslations,
    5: personTranslations,
    6: personTranslations,
    7: personTranslations,
    8: personTranslations,
    9: personTranslations,
  },
};

export default abstractContractClaimTranslations;
